/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect } from "react";
import { connect } from "react-redux";

// Dashboard example components
import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";

// Functions from store
import { getClients, ticketHomePageForClient } from "../../store";

// Cookies
import Cookies from "universal-cookie";
const cookies = new Cookies();

const ClientTicketsHomePage = ({
  getClients,
  ticketHomePageForClient,
  homePageForClientTickets,
  getClientsReducer,
}) => {
  let userData = cookies.get("loginDetailsForSupport");
  let token = userData?.token;

  useEffect(() => {
    ticketHomePageForClient(token);
  }, []);

  useEffect(() => {
    getClients(token);
  }, []);

  let clientsTickets = homePageForClientTickets.clientTickets.data
    ? homePageForClientTickets.clientTickets.data
    : [];
  let totalClients = getClientsReducer?.clients?.length;

  return (
    <SimpleBlogCard
      icon="contact_support"
      color="dark"
      title="Client Tickets"
      description={
        <span>
          <h4>Total Clients : {totalClients}</h4>
          <h4>To-Do Tickets :{clientsTickets.todo}</h4>
          <h4>In-Progress Tickets: {clientsTickets.inProgress}</h4>
          <h4>Completed:{clientsTickets.completed}</h4>
        </span>
      }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    homePageForClientTickets: state.homePageForClientTickets,
    getClientsReducer: state.getClientsReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ticketHomePageForClient: (token) =>
      dispatch(ticketHomePageForClient(token)),
    getClients: (token) => dispatch(getClients(token)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientTicketsHomePage);
